import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyledNetSuiteBillsPage} from '../NetSuiteBillsPage/StyledNetSuiteBillsPage';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader/BalancePageHeader';
import PageDocumentDetails from '../../components/PageDocumentDetails/PageDocumentDetails';
import VendorsTabs from '../../components/pages/NetSuiteVendorsPage/VendorsTabs';

const NetSuiteVendorsPage = () => {
  const [t] = useTranslation('main');

  const title = t('pageTitles.vendorsList');

  return (
    <StyledNetSuiteBillsPage>
      <PageDocumentDetails title={title} />
      <BalancePageHeader breadcrumbs={[{ title }]} />
      <DashboardPageTransition>
        <VendorsTabs />
      </DashboardPageTransition>
    </StyledNetSuiteBillsPage>
  );
}

export default NetSuiteVendorsPage;
